import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'momentLocalZone',
    standalone: false
})
export class MomentLocalZonePipe implements PipeTransform {
  transform(value: Date): any {
    if (!value) {
      return null;
    }
    return moment(new Date(value).toISOString()).tz(moment.tz.guess()).format('l LT z');
  }
}
@Pipe({
    name: 'momentDate',
    standalone: false
})
export class MomentDatePipe implements PipeTransform {
  transform(value: Date): any {
    if (!value) {
      return null;
    }
    return moment(new Date(value).toISOString()).tz(moment.tz.guess()).format('l');
  }
}
